export var makeGrid2Styles = function makeGrid2Styles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiGrid2: {
      defaultProps: {
        spacing: {
          xs: tokens.grid.xs.gutter,
          sm: tokens.grid.sm.gutter,
          md: tokens.grid.md.gutter,
          lg: tokens.grid.lg.gutter,
          xl: tokens.grid.xl.gutter
        }
      }
    }
  };
};